@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('hasError')) {
    @if (data.hasError) {
      <div
        class="flex items-center gap-2 text-red-500"
        tooltipPosition="bottom"
        [pTooltip]="data.errorMessage!">
        <app-icon [icon]="Icon.ExclamationCircleFill" />

        <span class="text-xs">Najedź kursorem, aby zobaczyć szczegóły</span>
      </div>
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('status')) {
    <app-invoice-status [status]="data.status" />
  }

  @case (getColumnKey('ksefStatus')) {
    <app-invoice-ksef-status [status]="data.ksefStatus" />
  }

  @case (getColumnKey('type')) {
    <app-invoice-type [type]="data.type" />
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
